<template>
  <div class="pa-6" :class="{ hide: !showAside }">
    <div v-if="isFoundLoading" style="height: 200px; display: flex; align-items: center; justify-content: center;"
      class="px-6 py-4 pb-2">
      <v-progress-circular width="2" size="32" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div class="aside-header">
        <div>
          <h2 v-if="found.length === 0" class="hb-font-header-2-medium hb-text-night">
            No Similar Contacts Found
          </h2>
          <h2 v-else class="hb-font-header-2-medium hb-text-night">Similar Contacts Found</h2>
        </div>
      </div>

      <div class="aside-summary-section">
        <div>
          <p v-if="found.length > 0" class="hb-body hb-text-night">
            There are similar contacts found. Do you want to use of these
            contacts?
          </p>

          <!-- <hb-btn color="secondary" @click="$emit('hide')">Hide</hb-btn> -->
        </div>
      </div>

      <div v-for="(contact, i) in found" :key="i">
        <hb-header one-action>
          <template v-if="contact?.id" v-slot:left>
            <mini-profile-view class="pa-0 mini-profile-view" :tenant-profile="true" :contact-id="contact.id" :use-contact="true"
              :contact-data="contact" @click.native="openDoNotRentModal(contact)" />              
              <div class="mt-0 ml-14 reason" v-if="isTenantInDoNotRentList(contact)?.reason || contact?.reason">
                  <strong>Reason:</strong> {{ isTenantInDoNotRentList(contact).reason || contact?.reason }}
              </div> 
          </template>
        </hb-header>
        <!-- <hb-btn @click="setContact(contact)" color="primary"
        >Use This Contact</hb-btn
      > -->
      </div>
      <do-not-rent-modal
            v-model="showDoNotRentModal" 
            v-if="showDoNotRentModal"
            :contacts="[selectedContact]"
            :loader="doNotRentLoader"
            @close="showDoNotRentModal = false"
            @process="processMoveIn"
            btn-text="Continue"
            confirmation-text="Do you still want to continue move-in?"
            :secondaryContent="TENANT.DNR_MODEL.MOVE_IN"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import Status from "../../includes/Messages.vue";
import Loader from "../../assets/CircleSpinner.vue";
import api from "../../../assets/api.js";
import moment from "moment";
import { charges } from "../../../mixins/leaseCharges.js";
import { parsePhoneNumber } from "libphonenumber-js";
import { mapGetters } from "vuex";
import MiniProfileView from "./MiniProfileView.vue";
import DoNotRentModal from '../DoNotRentModal.vue';
import TENANT from "@/constants/tenant.js";

export default {
  name: "FoundContacts",
  data() {
    return {
      showAside: true,
      found: [],
      showDoNotRentModal: false,
      doNotRentLoader: false,
      contactFlag: {},
      selectedContact: {}
    };
  },
  components: {
    MiniProfileView,
    DoNotRentModal
  },
  props: ["show", "contacts",'isFoundLoading'],
  created() {
    this.found = this.contacts;
    this.showAside = this.show;
    this.TENANT = TENANT;
  },
  computed: {
    ...mapGetters({
      selectedProperties: 'propertiesStore/filtered',
      hasPermission: 'authenticationStore/rolePermission',
    })
  },
  methods: {
    async openDoNotRentModal(contact) {
      this.doNotRentLoader = true;
      this.selectedContact = contact;  
      this.contactFlag = this.selectedContact?.contactFlags?.length > 0 ?  this.selectedContact?.contactFlags.find(flag => flag.slug == TENANT.TENANT_FLAGS.DO_NOT_RENT): {};
      if(this.contactFlag?.status){ 
        this.showDoNotRentModal = true;
      }else{
        await this.setContact();
      }
      this.doNotRentLoader = false;
    },
    async processMoveIn(){
      this.$store.commit('onBoardingStore/setIsMoveInPermissionGranted', true);
      this.doNotRentLoader = true;
      await this.setContact();
    },
    async setContact() {
      if(this.selectedContact?.id){
        this.doNotRentLoader = false;
        this.showDoNotRentModal = false;
        this.$emit("selected", this.selectedContact);
      }
    },
    isTenantInDoNotRentList(contact) {
        return contact?.contactFlags?.length > 0 ?  contact?.contactFlags.find(flag => flag.slug == TENANT.TENANT_FLAGS.DO_NOT_RENT): {};
    },
  },
  watch: {
    show(val) {
      this.showAside = val;
    },
    contacts(val) {
      this.found = this.contacts;
    },
  },
};
</script>
<style scoped>
.mini-profile-view{
  cursor: pointer;
}
.reason{
  color: #101318;
  font-size: 12px;
}
</style>
